module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"toUpgradePlan":"Upgrade plan","multiuser-na":"Multi-user mode is unavailable with your plan"}}')
  delete Component.options._Ctor
}
